export default {"src":"/spot-fe-premarket/_next/static/media/2.96c05336.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};